import React from 'react';
import { GoogleMap, withScriptjs, withGoogleMap, Marker } from 'react-google-maps';

const MapComponent = (props) => {
  const position = {
    lat: parseFloat(props.latitud),
    lng: parseFloat(props.longitud)
  };

  return (
    <GoogleMap
      zoom={15}
      center={position}
    >
      <Marker
        position={position}
        label={props.usuario}
      />
    </GoogleMap>
  );
};

export default withScriptjs(withGoogleMap(MapComponent));